import { RequestStatus } from 'typed/api';
import { ActionType, Action } from 'typed/actions';
import { IReducer, networkActionReducer } from './';
import { Entity, NetworkPaginationSlice, NetworkArray, IEntityReducerState, isPaginationSlice, isNetworkArray } from './entityReducers';
import { deepAssign, deepClone, DeepPartial } from 'typed/utils';

export default function entityLoadReducer<E extends Entity, T extends ActionType, S extends NetworkPaginationSlice<E>>(def: S, type: T, placeholder?: E): IReducer<S, Action<T>>;
export default function entityLoadReducer<E extends Entity, T extends ActionType, S extends NetworkArray<E>>(def: S, type: T, placeholder?: E): IReducer<S, Action<T>>;
export default function entityLoadReducer<E extends Entity, T extends ActionType, S extends E[]>(def: S, type: T, placeholder?: E): IReducer<S, Action<T>>;
export default function entityLoadReducer<E extends Entity, T extends ActionType>(def: E, type: T): IReducer<E, Action<T>>;
export default function entityLoadReducer<E extends Entity, T extends ActionType>(def: E | IEntityReducerState<E>, type: T, placeholder?: E): IReducer<E | IEntityReducerState<E>, Action<T>> {
    const nr = networkActionReducer<T, E>(type);
    return function entityLoadReducer(state = deepClone(def), action) {
        if (action.type === type) {
            let
                cstate: IEntityReducerState<E> = state as IEntityReducerState<E>,
                data = isNetworkArray(cstate) ? cstate.Data : Array.isArray(cstate) ? cstate : [state as E],
                index = data.getIndexByID(action.payload.entityID),
                entity = data[index] || placeholder;
            if (entity || action.payload.status === RequestStatus.SUCCEEDED) {
                if (action.payload.status === RequestStatus.UNSYNCED) {
                    entity = deepAssign(entity, { ID: action.payload.entityID } as DeepPartial<E>);
                }
                else if (action.payload.status === RequestStatus.SUCCEEDED) {
                    entity = action.payload.response ?
                        deepAssign(action.payload.response, { Custom: { internalID: (entity || action.payload.response).Custom.internalID } } as DeepPartial<E>) :
                        action.payload.response;
                }

                data = entity ?
                    deepAssign(data, { [index !== -1 ? index : data.length]: nr(entity, action) }) :
                    data.filter((_, i) => i !== index);
            }

            return isPaginationSlice(cstate) && action.payload.status === RequestStatus.SUCCEEDED && !cstate.Data.getByID(action.payload.entityID) ?
                deepAssign(cstate, { Data: data, Count: cstate.Count + 1 }) :
                isNetworkArray(cstate) ?
                    deepAssign(cstate, { Data: data }) :
                    Array.isArray(cstate) ? data : data[0];
        }

        // assertNever(state);
        return state;
    }
}